import React, { forwardRef } from "react"
import MDInputRoot from "./MDInputRoot"
import { MDInputProps } from "./types"

const MDInput = forwardRef<HTMLInputElement, MDInputProps>(
  ({ error = false, success = false, disabled = false, ...rest }, ref) => (
    <MDInputRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} />
  )
)

MDInput.displayName = "MDInput"

export default MDInput
